import { gql } from "@apollo/client";
export const BankAccountsFind = gql `
  query BankAccountsFind($query: QueryInput) {
    BankAccountsFind(query: $query) {
      _id
      accountNumber
      formattedAccountNumber
      bankId
      bank {
        name
      }
      currency
    }
  }
`;
